module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "background": "#FAF9F5"
    }
  }, [_c('section', {
    staticClass: "blog-posts-area section-padding"
  }, [_c('div', {
    staticClass: "container",
    staticStyle: {
      "background": "#fff"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 post-list blog-post-list"
  }, [_c('div', {
    staticClass: "single-post"
  }, [_c('h2', {
    staticClass: "blog-detail-tit"
  }, [_vm._v("\n                  " + _vm._s(_vm.currentBlog.title) + "\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "blog-detail-img"
  }, [_c('img', {
    staticClass: "img-fluid wow slideInLeft",
    attrs: {
      "src": _vm.currentBlog.img,
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "blog-detail-content content-wrap wow slideInRight"
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.currentBlog.content)
    }
  })])])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-33d9f8a0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/BlogDetails.vue
// module id = 72
// module chunks = 0